import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { createWatchListEntry } from "../../actions";
import UpsertWatchListEntryForm from "../../components/upsert-watch-list-entry-form";
import {
  nationalitiesOptionsSelector,
  countriesOptionsSelector,
  selectCreateWatchListEntryEuTerroristLoading,
} from "../../selectors";
import { getCountries, getNationalities } from "../../../../actions";
import { trimFormData } from "../../../../utilities/filters";

const CreateWatchListEntryPage = () => {
  const dispatch = useDispatch();
  const nationalities = useSelector(nationalitiesOptionsSelector);
  const countries = useSelector(countriesOptionsSelector);
  const isLoading = useSelector(selectCreateWatchListEntryEuTerroristLoading);

  useEffect(() => {
    dispatch(getNationalities());
    dispatch(getCountries());
  }, []);

  const handleSubmit = (data) => {
    const trimmedData = trimFormData(data);
    dispatch(createWatchListEntry(trimmedData));
  };

  return (
    <UpsertWatchListEntryForm
      handleSubmit={handleSubmit}
      countries={countries}
      nationalities={nationalities}
      isLoading={isLoading}
    />
  );
};

export default CreateWatchListEntryPage;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/pages/create-watch-list-entry-page/CreateWatchListEntryPage.jsx